import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const EmailTemplateRaw = React.lazy(() => import(/* webpackChunkName: "EmailTemplate" */ './EmailTemplates'));
export const EmailTemplate = () => (React.createElement(Page, { title: "Email Templates List", description: "Email Templates List" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(EmailTemplateRaw, null)))));
